<template>
  <div class="list" v-loading="loading">
    <div
      v-for="(item, index) in list"
      v-loading="item.loading"
      element-loading-text="正在删除"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :key="index"
      :class="['block', model === item.id ? 'active' : '']"
    >
      <span class="tag" v-if="item.id === model">默认</span>
      <el-radio
        v-if="item.id !== model"
        v-model="model"
        :label="item.id"
        @input="handleSetDefault(item)"
      >
        设为默认
      </el-radio>
      <el-image
        style="width: 500px; height: 140px"
        :src="item.sign"
        fit="contain"
        @click.native="handleSelect(item)"
      />
      <i
        class="su-icon-delete delete"
        title="删除"
        @click="handleRemove(item, index)"
      ></i>
    </div>
  </div>
</template>

<script>
import alertUtils from '../../util/alertUtils'
import request from '../../util/request'
import { config } from '../../config/config'
export default {
  props: {
    currentData: Object,
  },
  data() {
    return {
      list: [],
      loading: false,
      model: '',
    }
  },
  created() {
    this.getData()
  },
  watch: {
    currentData: {
      handler(val) {
        if (val) {
          this.model = val.id
        }
      },
      deep: true,
      immediate: true,
    },
    // model(value) {
    //   const data = this.list.find(listItem => listItem.id === value)
    //   this.$emit('change', data)
    // },
  },
  methods: {
    getData() {
      this.loading = true
      request({
        url: config.baseAPI + '/v1/sign/all',
        method: 'get',
      })
        .then(res => {
          this.list = res.data.map(item => {
            item.loading = false
            return item
          })
        })
        .catch(error => {
          alertUtils.alertError(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSelect(item) {
      // 处理el-image组件bug 点击图片body会添加overflow：hidden导致滚动条消失
      document.body.style.overflow = 'auto'
      this.$emit('change', item)
    },
    handleSetDefault(item) {
      this.$emit('set-default', item)
      this.model = item.id
    },
    handleRemove(item, index) {
      this.$confirm('确认删除这张签名吗?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          item.loading = true
          return request({
            url: config.baseAPI + '/v1/sign/delete',
            method: 'delete',
            params: {
              id: item.id,
            },
          })
        })
        .then(res => {
          if (res.flag) {
            alertUtils.alertSuccess(res.msg, true)
            this.list.splice(index, 1)
          } else {
            alertUtils.alertWarning(res.msg, true)
          }
          item.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.block {
  position: relative;
  margin-bottom: 10px;
  width: 500px;
  height: 150px;
  background: #f1f3f6;
  border-radius: 10px;
  border: 1px solid #d9dce0;
  display: flex;
  align-items: center;

  &.active {
    border: 1px solid #1574df;
  }

  .tag {
    position: absolute;
    left: 14px;
    top: 14px;
    font-size: 12px;
    padding: 0 8px;
    line-height: 22px;
    background: linear-gradient(212deg, #20a5e8 0%, #0e6ccb 100%);
    border-radius: 4px;
    color: #fff;
  }

  .el-radio {
    position: absolute;
    left: 14px;
    bottom: 14px;
    margin: 0;
    z-index: 10;
  }
}

.delete {
  position: absolute;
  bottom: 14px;
  right: 14px;
  cursor: pointer;
}

.list {
  max-height: 70vh;
  min-height: 200px;
  min-width: 360px;
  overflow-y: auto;
}
</style>
